(function () {
	let isInitialized = false;

	window.addEventListener('DOMContentLoaded', () => {
		if (!isInitialized) {
			isInitialized = true;
		}
	});

	const lazyVideos = document.querySelectorAll('.lazy-video-ad');

	// Set element aspect ratio based on video width and height
	lazyVideos.forEach((video) => {
		const desktopVideo = video.querySelector(
			'source[media="(min-width: 782px)"]'
		);
		const mobileVideo = video.querySelector(
			'source[media="(max-width: 781px)"]'
		);

		const vw = Math.max(
			document.documentElement.clientWidth || 0,
			window.innerWidth || 0
		);
		const aspectRatio =
			vw < 782
				? mobileVideo.dataset.aspectRatio
				: desktopVideo.dataset.aspectRatio;

		video.style.aspectRatio = aspectRatio;
	});

	if ('IntersectionObserver' in window) {
		const videoObserver = new IntersectionObserver(
			(entries, observer) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						const video = entry.target.querySelector('video');
						const sources =
							video.querySelectorAll('source[data-src]');

						sources.forEach((source) => {
							source.src = source.dataset.src;
							source.removeAttribute('data-src');
						});

						video.load(); // Start loading the video
						video.play(); // Autoplay once loaded
						observer.unobserve(video); // Stop observing after loading
					}
				});
			},
			{
				rootMargin: '200px',
				threshold: 0,
			}
		);

		lazyVideos.forEach((video) => {
			videoObserver.observe(video);
		});
	} else {
		// Fallback for browsers without IntersectionObserver
		lazyVideos.forEach((video) => {
			const sources = video.querySelectorAll('source[data-src]');
			sources.forEach((source) => {
				source.src = source.dataset.src;
				source.removeAttribute('data-src');
			});
			video.load();
			video.play();
		});
	}
})();
